import {action, makeObservable, observable} from 'mobx';

type DataProps = {
    General: [
        {
            licensedto: string;
            Company: Company[];
        }
    ];
};

export type Company = {
    Color: [{red: string; green: string; blue: string}];
    country: string;
    dname: string;
    prettyname: string;
    title: string;
    EnvProfile?: [{profilename: string; profile: string}];
};

export class SelectCompanyStore {
    constructor() {
        makeObservable(this);
    }
    @observable companies: Company[] = [];
    @observable company: Company = null;
    @observable canCancel: boolean = false;
    @observable licensedto: string = '';
    @observable isOpen: boolean = false;
    @observable privilegeGroup: {profilename: string; profile: string} = null;

    @action setCompanies = (data: DataProps) => {
        const companies = data?.General?.[0]?.Company;
        if (companies) {
            this.companies = companies;
        }
    };

    @action setCompany = (companyName: string) => {
        const company = this.companies.find(company => company.dname === companyName);
        this.company = company;
        if (company?.EnvProfile) {
            this.setPrivilegeGroup(company.EnvProfile?.[0].profilename);
        }
    };

    getProfile = () => {
        const profile = this.privilegeGroup?.profile;
        return profile ? Number(profile) : 0;
    };

    @action setPrivilegeGroup = (profilename: string) => {
        const privilegeGroup = this.company?.EnvProfile?.find(profile => {
            return profile.profilename === profilename;
        });
        this.privilegeGroup = privilegeGroup;
    };

    getDName = () => {
        return this.company?.dname || '';
    };

    getPrettyName = () => {
        // Find the first company that has a prettyname
        const companyWithPrettyName = this.companies.find(company => company.prettyname);
        return companyWithPrettyName?.prettyname || '';
    };

    @action setCanCancel = (canCancel: boolean) => {
        this.canCancel = canCancel;
    };
    @action setLicensedTo = (data: DataProps) => {
        const licensedto = data?.General?.[0].licensedto;
        if (licensedto) {
            this.licensedto = licensedto;
        }
    };
    @action setIsOpen = (isOpen: boolean) => {
        this.isOpen = isOpen;
    };

    @action initStoreData = props => {
        const {data, company} = props;

        this.setCompanies(data);
        this.setLicensedTo(data);

        if (!!company) {
            this.setCompany(company);
        }

        if (!this.company) {
            if (this.companies) {
                this.setCompany(this.companies[0]?.dname);
            }
        } else {
            this.setCanCancel(true);
        }
    };

    // Reset store should only be used for testing purposes.
    @action resetStore = () => {
        this.companies = [];
        this.company = null;
        this.canCancel = false;
        this.privilegeGroup = null;
        this.licensedto = '';
    };
}

export const selectCompanyStore = new SelectCompanyStore();
